import { render } from "./orders_completed_trends.vue?vue&type=template&id=4031b16e&scoped=true"
import script from "./orders_completed_trends.vue?vue&type=script&lang=js"
export * from "./orders_completed_trends.vue?vue&type=script&lang=js"

import "./orders_completed_trends.vue?vue&type=style&index=0&id=4031b16e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4031b16e"]])

export default __exports__